import { render, staticRenderFns } from "./ys2_monitor_module.vue?vue&type=template&id=5b121ace&"
import script from "./ys2_monitor_module.vue?vue&type=script&lang=js&"
export * from "./ys2_monitor_module.vue?vue&type=script&lang=js&"
import style0 from "./ys2_monitor_module.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports